import { NgModule } from '@angular/core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzProgressSpinnerModule } from '@blk/daisy/core/loading';
import { AnalyticsModule } from '@ddt-web/analytics';
import { BfaComponentsModule, SharedModule } from '@ddt-web/common';
import { CoreModule } from '@ddt-web/data-layer-components';
import { DataServiceModule } from '@ddt-web/data-service';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { StoreServiceModule } from '@ddt-web/store-service';
import { EffectsModule } from '@ngrx/effects';

import { PortfolioTableModule } from '../portfolio-table/portfolio-table.module';
import { NewAnalysisComponent } from './new-analysis.component';

@NgModule({
	declarations: [NewAnalysisComponent],
	imports: [
		BfaComponentsModule,
		CoreModule,
		CwpNgFrameworkModule,
		DataServiceModule,
		EffectsModule,
		MatDialogModule,
		SharedModule,
		StoreServiceModule,
		PortfolioTableModule,
		AnalyticsModule,
		GenericDirectivesModule,
		DzProgressSpinnerModule
	],
	exports: [NewAnalysisComponent]
})
export class NewAnalysisModule { }
